import { makeHook } from "../../utils/makeSingleArgHook";
import getTransitions from "../requests/getTransitions";
import { transitionsUrl } from "../requests/urls";
export function transitionsKeyMaker(queryParams) {
    if (queryParams === null) {
        return [transitionsUrl()];
    }
    return [transitionsUrl(), JSON.stringify(queryParams)];
}
const useGetTransitions = makeHook(async (queryParams, auth) => getTransitions(auth, queryParams), (queryParams) => transitionsKeyMaker(queryParams));
export default useGetTransitions;
//# sourceMappingURL=useGetTransitions.js.map